module.exports = "<section class=\"app-footer\">\n    <div class=\"container-fluid\">\n        <span class=\"float-left\">\n         <!-- <span>Copyright © <a class=\"brand\" target=\"_blank\" [href]=\"AppConfig.productLink\">{{AppConfig.corporate}}</a> {{AppConfig.year}}</span> -->\n         <span>Copyright © <a class=\"brand\" >{{AppConfig.corporate}}</a> {{AppConfig.year}}</span>\n     \n        </span>   \n        \n    </div>\n</section>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/footer/footer.component.html
// module id = 1152
// module chunks = 9